import saveAs from 'file-saver';

const ALLOWED_DOWNLOAD_PROTOCOLS = new Set(['http:', 'https:']);

const isSafeDownloadUrl = (url: string): boolean => {
  try {
    return ALLOWED_DOWNLOAD_PROTOCOLS.has(
      new URL(url, window.location.origin).protocol
    );
  } catch {
    return false;
  }
};

const sanitizeFilename = (name?: string): string => {
  if (!name) {
    return '';
  }
  return name.replace(/[/\\?%*:|"<>]/g, '_').slice(0, 255);
};

export const downloadBlob = (blob: Blob, name?: string) => {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = sanitizeFilename(name);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
};

// Hand the URL to the browser via an anchor click (file-saver's saveAs) rather
// than re-fetching it in JS. The media-streamer download endpoint authenticates
// from the session cookie; a JS `fetch` without `credentials: 'include'` drops
// that cookie and 401s, which is the VE-21971 failure. Anchor-click downloads
// inherit the browser's auth context the same way the customer's manual URL
// workaround does.
export const downloadNow = (url: string, name?: string): void => {
  if (!isSafeDownloadUrl(url)) {
    console.error('Blocked unsafe download URL');
    return;
  }
  saveAs(url, sanitizeFilename(name));
};
